export default __webpack_public_path__ + "static/media/hong-kong-1990268_1920.05f11f22.jpg";